/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box, IconButton } from "@mui/material";

export const StyledImageContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90vw',
  maxHeight: '90vh',
  outline: 'none'
})

export const ImageCloseButton = styled(IconButton)({
  position: 'absolute',
  top: '-40px',
  right: '-40px',
  backgroundColor: '#fff',
})

export const StyledImagePreview = styled('img')(({ imageLoaded }) => ({
  maxWidth: '100%',
  maxHeight: '90vh',
  borderRadius: '8px',
  display: imageLoaded ? "block" : "none"
}))
